import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import Layout from '../Layout';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
  },
}));

export default function Success() {
  const classes = useStyles();
  return (
    <Layout>
      <Box flex padding={5}>
        <Paper className={classes.container}>
          <Typography variant="h2" gutterBottom>
            Success!
          </Typography>
          <Typography>
            Congratulations on completing the form, and thank you for helping the broader
            engineering community have more compensation transparency.
            We will send the report your way as soon as it is ready.
          </Typography>
        </Paper>
      </Box>
    </Layout>
  );
}
